export default __webpack_public_path__ + "static/media/question-sign-in-circles-svgrepo-com.d3ee9bb6.svg";